import { LAND_TYPE, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { Gallery } from "src/libs/useful"
import { NAVIGATION_TYPE } from "src/libs/useful/gallery/Gallery"
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import EventCard from "../components/EventCard"

const ToposFooter = () : JSX.Element => {
    const lands:ILand[] = useDataStore((state: any) => state.Land || [])
    const {width} = useScreenSize()

    const events = lands.filter(event => event.land_type === LAND_TYPE.EVENT)
    const isCarousel: boolean = events.length > (width < WINDOW_WIDTH.TABLET ? 1 : 3) 
    const eventCards = events.map( event => <EventCard item={event} key={event.id} height="100%" width={isCarousel ? 100 : 33} /> )

    return <div className=" topos-footer-container w-100 flex-centered">
        <div className="row w-100 h-100"> 
        {
            !isCarousel
                ?
                eventCards
                :
                <Gallery 
                    items={ [
                        ...eventCards,
                    ] } 
                    itemWidth="100%"                
                    itemHeight={ 280 } 
                    count={{
                        [WINDOW_WIDTH.PANEL]    : 3,
                        [WINDOW_WIDTH.LARGE]    : 3,
                        [WINDOW_WIDTH.SCREEN]   : 3,
                        [WINDOW_WIDTH.TABLET]   : 2,
                        [WINDOW_WIDTH.MOBILE]   : 1,
                        [WINDOW_WIDTH.SMALL]    : 1,
                    }}
                    loop
                    type="element"
                    padding={ 0 }
                    navigation
                    navigationType={NAVIGATION_TYPE.SQUARE_RED}
                    pagination={false}
                />
        }
        </div>
    </div>
}

ToposFooter.propTypes = {}

export default ToposFooter